import { Currency, getInternalPlatformIdFromExternalPlatformId } from "@orb-labs/types";
import { CHAIN_CONFIGS } from "../constants.js";
export const initializePlatformInformation = async (orbyUrl) => {
    const response = await fetch(orbyUrl, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            jsonrpc: "2.0",
            method: "orby_listPlatformsInformation",
            params: [],
            id: 1,
        }),
    });
    const { result, error } = await response.json();
    if (error?.code && error?.message) {
        console.error("[initializePlatformInformation]", error.code, error.message);
        return;
    }
    result?.edges?.forEach((platformInformation) => {
        const platformId = getInternalPlatformIdFromExternalPlatformId(platformInformation.platformId);
        if (platformId && platformInformation?.name) {
            CHAIN_CONFIGS[Number(platformId)] = extractPlatformInformation(platformInformation);
        }
    });
};
export const extractPlatformInformation = (platformInformation) => {
    if (!platformInformation) {
        return undefined;
    }
    return {
        platformId: getInternalPlatformIdFromExternalPlatformId(platformInformation.platformId),
        environment: platformInformation.environment,
        logoUrl: platformInformation.logoUrl,
        name: platformInformation.name,
        vmType: platformInformation.vmType,
        nativeCurrency: Currency.toCurrency(platformInformation.nativeCurrency),
        isLive: platformInformation.isLive,
    };
};
export const hasError = (data) => {
    if (data?.code && data?.message) {
        return { code: data.code, message: data.message };
    }
    return undefined;
};
